import type { ReceiptsFilter } from './types'

/**
 * Отбор, каким он уходит в службу. Пустые даты — «сегодня» (по часам человека): журнал открывается на сегодняшнем дне,
 * а не на всей истории. Выбрана смена — дни не применяются вовсе: смена задаёт период сама и может идти через полночь.
 */
export function effectiveFilter(filter: ReceiptsFilter, today: string): ReceiptsFilter {
  if (filter.shiftNumber !== '') return { ...filter, dateFrom: '', dateTo: '' }
  const dateFrom = filter.dateFrom === '' ? today : filter.dateFrom
  const dateTo = filter.dateTo === '' ? today : filter.dateTo
  return { ...filter, dateFrom, dateTo: dateTo < dateFrom ? dateFrom : dateTo }
}

/**
 * Показывать ли список чеков. Список — за один день или за смену; период из нескольких дней показывает только сводку и
 * график: чеки за неделю или год не выгружаются, их ищут, выбрав день.
 */
export function listShownOf(filter: ReceiptsFilter, today: string): boolean {
  const effective = effectiveFilter(filter, today)
  return effective.shiftNumber !== '' || effective.dateFrom === effective.dateTo
}

/** Отбор итогов: тот же, но без вида чека — приход и возвраты считаются оба, чипы вида их только разделяют. */
export function summaryFilterOf(filter: ReceiptsFilter): ReceiptsFilter {
  return { ...filter, kind: '' }
}
